import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../../environments/environment";
import {PageQueryInterface} from "../../../_models/page.interface";

@Injectable({
    providedIn: 'root',
})
export class NewCertificationService {
    private readonly CERT_API: string;

    constructor(private http: HttpClient) {
        this.CERT_API = `${environment.apiUrl}/new-admin/new-certification`;
    }

    async getAll(pageQuery: PageQueryInterface): Promise<any> {
        return await this.http.post(this.CERT_API + `/all`, pageQuery).toPromise();
    }

    async getById(certificationId: number): Promise<any> {
        return await this.http.get(this.CERT_API + `/get-one/${certificationId}`).toPromise();
    }

    async getDomainsByCertificationId(certificationId: number): Promise<any> {
        return await this.http.get(this.CERT_API + `/get-one/${certificationId}/domains`).toPromise();
    }

    async save(payload: any): Promise<any> {
        return await this.http.post(this.CERT_API + `/save`, payload).toPromise();
    }

    async update(payload: any): Promise<any> {
        return await this.http.put(this.CERT_API + `/edit`, payload).toPromise();
    }

    async delete(certificationId: number): Promise<any> {
        return await this.http.post(this.CERT_API + `/delete/${certificationId}`, {}).toPromise();
    }

    async deleteCertification(certificationId: number): Promise<any> {
        return await this.http.delete(this.CERT_API + `/get-one/${certificationId}`).toPromise();
    }

    async updateCertificationInformation(payload: any, certificationId: number): Promise<any> {
        return await this.http.put(this.CERT_API + `/get-one/${certificationId}/certification`, payload).toPromise();
    }

    async getAllDomains(pageQuery: PageQueryInterface, certificationId: number): Promise<any> {
        return await this.http.post(this.CERT_API + `/all-domains/${certificationId}`, pageQuery).toPromise();
    }

    async updateCertificationDomain(payload: any, certificationId: number, domainId: number): Promise<any> {
        return await this.http.put(this.CERT_API + `/get-one/${certificationId}/domain/${domainId}`, payload).toPromise();
    }

    async deleteCertificationDomain(certificationId: number, domainId: number): Promise<any> {
        return await this.http.delete(this.CERT_API + `/get-one/${certificationId}/domain/${domainId}`).toPromise();
    }

    async deleteCertificationDomainObjective(certificationId: number, domainId: number, objectiveId: number): Promise<any> {
        return await this.http.delete(this.CERT_API + `/get-one/${certificationId}/domain/${domainId}/objective/${objectiveId}`).toPromise();
    }

    async saveCertificationDomain(payload: any, certificationId: number): Promise<any> {
        return await this.http.post(this.CERT_API + `/get-one/${certificationId}/domain`, payload).toPromise();
    }

    async updateCertificationDomainObjective(payload: any, certificationId: number, domainId: number, objectiveId: number): Promise<any> {
        return await this.http.put(this.CERT_API + `/get-one/${certificationId}/domain/${domainId}/objective/${objectiveId}`, payload).toPromise();
    }

    async getActivityByCertificationId(certificationId: number): Promise<any> {
        return await this.http.get(this.CERT_API + `/list-activities/${certificationId}`).toPromise();
    }

    async countDomains(certificationId: number): Promise<any> {
        return await this.http.get(this.CERT_API + `/get-domains/${certificationId}/count`).toPromise();
    }

    async countActivities(certificationId: number): Promise<any> {
        return await this.http.get(this.CERT_API + `/get-activities/${certificationId}/count`).toPromise();
    }

    async countObjectives(certificationId: number): Promise<any> {
        return await this.http.get(this.CERT_API + `/get-objectives/${certificationId}/count`).toPromise();
    }

    async countTerms(certificationId: number): Promise<any> {
        return await this.http.get(this.CERT_API + `/get-terms/${certificationId}/count`).toPromise();
    }

    ///new-certification/get-domains/{certificationId}/count

}
